import script from "./NewsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsView.vue?vue&type=script&lang=ts&setup=true"

import "./NewsView.vue?vue&type=style&index=0&id=71f7911b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f7911b"]])

export default __exports__